import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ to = "/", size = "md", showText = true, onClick, animated = false }) {
  const h = { sm: 32, md: 46, lg: 76, xl: 140 }[size] || 46;
  const src = showText ? "/brand/gv-logo-full.png" : "/brand/gv-monogram.png";
  const inner = (
    <img
      src={src}
      alt="GameView Studio"
      style={{ height: h, width: "auto", maxWidth: "100%" }}
      className={`object-contain object-left drop-shadow-[0_2px_18px_rgba(124,58,237,0.45)] ${animated ? "brand-pulse" : ""}`}
      data-testid="brand-logo"
    />
  );
  if (onClick) return <button onClick={onClick} className="focus:outline-none">{inner}</button>;
  return <Link to={to} className="focus:outline-none flex items-center min-w-0">{inner}</Link>;
}
